module.exports = __webpack_public_path__ + "images/home-mid.e113ab5.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/image/home-mid.png
// module id = 638
// module chunks = 0